import React, { memo, useEffect, useState } from "react";
import { Button, Card, Col, FormControl, InputGroup, Row } from "react-bootstrap";
import StillageDataTable from "../stillage-table/StillageDataTable";
import PropTypes from 'prop-types';
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat'

const AgedStillages = ({ data, loading }) => {
    dayjs.extend(customParseFormat);
    const [days, setDays] = useState(90);
    const [filteredData, setFilteredData] = useState([]);

    const filterData = () => {
        if (!Array.isArray(data)) {
            setFilteredData([]);
            return;
        }

        const n = Number(days) || 0;
        setFilteredData(
            data.filter(item => {
                if (!item || !item.deliveryDate)
                    return false;
                return dayjs(item.deliveryDate, 'DD-MM-YYYY').isAfter(dayjs().subtract(n, 'day'));
            })
        );
    };

    useEffect(() => { if (data) filterData(); }, [data]);

    return (
        <>
            <Row className="mb-2">
                <Col xs={4}>
                    <Card.Title className="text-700 mb-2">Aged Stillages <br /><small>Days Since Delivery</small></Card.Title>
                </Col>
                <Col xs={3}>
                    <InputGroup>
                        <FormControl
                            type="number"
                            value={days}
                            onChange={e => setDays(parseInt(e.target.value || '0', 10))}
                        />
                        <InputGroup.Text>Days</InputGroup.Text>
                    </InputGroup>
                </Col>
                <Col>
                    <Button variant="info" onClick={filterData}>Filter Aged</Button>
                </Col>
            </Row>
            <Row>
                <StillageDataTable data={filteredData} loading={loading} hover={false} />
            </Row>
        </>
    )
}

AgedStillages.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
};

export default memo(AgedStillages);